import { __decorate, __extends, __metadata } from "tslib";
import { FileManagerBase } from './FileManager';
import { Utils } from '../../Utils';
import NeoModel from '../../Model/NeoModel';
var BoundFileManager = /** @class */ (function (_super) {
    __extends(BoundFileManager, _super);
    function BoundFileManager(uploadEndpoint, options) {
        return _super.call(this, uploadEndpoint, options) || this;
    }
    BoundFileManager.prototype.afterUpload = function (response) {
        if (response.files.length) {
            var file = response.files[0];
            var model = this.options.bind.attachedTo, wasDirty = model.isSelfDirty;
            this.options.bind.value = file.fileDescriptorId;
            if (this.options.fileDescriptorProperty) {
                var fileDescriptor = this.options.fileDescriptorProperty.value;
                if (typeof fileDescriptor === "string") {
                    // File descriptor is just a string name.
                    this.options.fileDescriptorProperty.value = file.fileName;
                }
                else {
                    // File descriptor is an object of type IFileDescriptor.
                    if (!fileDescriptor) {
                        var type = this.options.fileDescriptorProperty.propertyInfo.type;
                        if (type) {
                            fileDescriptor = Utils.createInstance(type);
                            this.options.fileDescriptorProperty.value = fileDescriptor;
                        }
                    }
                    fileDescriptor.set(file);
                }
            }
            if (response.linkedToEntity && !wasDirty) {
                model.isSelfDirty = false;
            }
        }
    };
    /** Clears the bind value, and descriptor value. */
    BoundFileManager.prototype.clearFile = function () {
        this.options.bind.value = "";
        this.options.bind.validator.hasBlurred = true;
        if (this.options.fileDescriptorProperty) {
            var fileDescriptor = this.options.fileDescriptorProperty.value;
            if (typeof fileDescriptor === "string") {
                // File descriptor is just a string name.
                this.options.fileDescriptorProperty.value = "";
            }
            else {
                // File descriptor is an object of type IFileDescriptor.
                this.options.fileDescriptorProperty.value = null;
            }
        }
    };
    BoundFileManager = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [String, Object])
    ], BoundFileManager);
    return BoundFileManager;
}(FileManagerBase));
export default BoundFileManager;
